import { useCallback, useEffect, useRef, useState } from "react";
import TempoKeyChip from "@/components/tempo/TempoKeyChip";
import { analyzeTempoKey, decodeSong } from "@/lib/tempoKey";
import { saveSourceTempo, sourceAudioUrl } from "@/lib/studioApi";

/** Tempo + key of your uploaded loop/song — found right after upload, correctable, kept with the upload. */
export default function SourceTempo({ projectId, source, onSource }) {
  const [detecting, setDetecting] = useState(false);
  const [failed, setFailed] = useState(false);
  const tried = useRef(null);
  const keep = useCallback(async (tempo) => {
    onSource({ ...source, tempo });
    try { await saveSourceTempo(projectId, tempo); } catch { /* shown locally; saved next time */ }
  }, [onSource, projectId, source]);
  const detect = useCallback(async () => {
    setDetecting(true);
    setFailed(false);
    try { await keep(await analyzeTempoKey(await decodeSong(sourceAudioUrl(projectId, source)))); }
    catch { setFailed(true); }
    finally { setDetecting(false); }
  }, [keep, projectId, source]);
  useEffect(() => {
    if (source.tempo || tried.current === source.uploaded_at) return;
    tried.current = source.uploaded_at;
    detect();
  }, [detect, source.tempo, source.uploaded_at]);
  return (
    <div data-testid="source-tempo" className="space-y-1">
      <TempoKeyChip tempo={source.tempo || null} detecting={detecting} onChange={keep} onRedetect={detect} />
      {failed && !source.tempo ? <p data-testid="source-tempo-failed" className="text-[11px] text-white/45">Couldn't find the tempo and key — press Set to enter them.</p> : null}
    </div>
  );
}
